import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListExtraInfoContainer = styled.div<React.CSSProperties>`
  display: flex;
  margin-left: ${6 * Screen.widthRatio}px;
`;

export default ChannelListExtraInfoContainer;
